import { gql } from 'apollo-angular';

const GET_ALL_RFP = gql`
  query rfps {
    rfps {
      id
      category {
        id
        name
        type
        status
        effectiveDate
        terminationDate
        categorizationScheme {
          id
          name
        }
      }
      status
      submissionDate
      offersReceivedDate
      pricingExpirationDate
      offersDueDate
      preferredContractEffectiveDate
      preferredContractDuration
      type
      buyer {
        id
        name
        organizationType
      }
      statistics {
        sellerCount
        responseCount
        offerCount
        cpaCount
        buyerExecutedCpaCount
        systemCount
        participantCount
        publishedPlanCount
        activePlanCount
        primaryCategoryCount
        leafCategoryCount
        signedCpaCount
        standardCategoriesWithActiveCaCount
        publishedPlanOptedInCount
        carveInUnspscCount
        standardUnspscCount
        productCount
      }
      purchasePlanAccessible
      releaseHoldDate
      actualSpend
      continuedSpend
    }
  }
`;

export default GET_ALL_RFP;
